import _classCallCheck from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createSuper";
import state$1 from './shared/state.js';
import { whileMuted } from './shared/utils.js';
import { debug as debug$1 } from './shared/debug.js';
import { createShallow } from './proxyManager.js';
import { removeListenersForComponent } from './updateManager.js';
import React$1 from 'react';
import hoistNonReactStatics$1 from 'hoist-non-react-statics'; // As we render down into a tree of collected components, we will start/stop
// recording

var componentStack = [];

var startRecordingGetsForComponent = function startRecordingGetsForComponent(component) {
  if (!state$1.isInBrowser) return;
  debug$1(function () {
    console.groupCollapsed("RENDER: <".concat(component._name, ">"));
  });
  state$1.currentComponent = component;
  componentStack.push(state$1.currentComponent);
};

var stopRecordingGetsForComponent = function stopRecordingGetsForComponent() {
  if (!state$1.isInBrowser) return;
  debug$1(function () {
    console.groupEnd();
  });
  componentStack.pop();
  state$1.currentComponent = componentStack[componentStack.length - 1] || null;
};
/**
 * This shallow clones the store to pass as state to the collected
 * component.
 */


var getStoreClone = function getStoreClone() {
  return whileMuted(function () {
    // We'll shallow clone the store so React knows it's new
    var shallowClone = Object.assign({}, state$1.store); // ... but redirect all reads to the real store

    state$1.nextVersionMap.set(shallowClone, state$1.store);
    return createShallow(shallowClone);
  });
};

var collect = function collect(ComponentToWrap) {
  var componentName = ComponentToWrap.displayName || ComponentToWrap.name || 'NamelessComponent';

  var WrappedComponent = /*#__PURE__*/function (_React$1$PureComponen) {
    _inherits(WrappedComponent, _React$1$PureComponen);

    var _super = _createSuper(WrappedComponent);

    function WrappedComponent() {
      var _this;

      _classCallCheck(this, WrappedComponent);

      _this = _super.apply(this, arguments);
      _this.state = {
        // This might be called by React when a parent component has updated with a new store,
        // we want this component (if it's a child) to have that next store as well.
        store: getStoreClone()
      }; // TODO (davidg) 2020-02-28: use private #isMounted, waiting on
      //  https://github.com/prettier/prettier/issues/7263

      _this._isMounted = false;
      _this._isMounting = true; // <React.StrictMode> will trigger multiple renders,
      // we must disregard these

      _this._isRendering = false;
      _this._name = componentName;
      return _this;
    }

    _createClass(WrappedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this._isMounted = true;
        this._isMounting = false; // Stop recording. For first render()

        stopRecordingGetsForComponent();
        this._isRendering = false;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        // Stop recording. For not-first render()
        stopRecordingGetsForComponent();
        this._isRendering = false;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        removeListenersForComponent(this);
        this._isMounted = false;
      }
    }, {
      key: "update",
      value: function update() {
        // 1. If the component has already unmounted, don't try and set the state
        // 2. The component might not have mounted YET, but is in the middle of its first
        //    render cycle.
        //    For example, if a user sets store.loading to true in App.componentDidMount
        if (this._isMounted || this._isMounting) {
          this.setState({
            store: getStoreClone()
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (!this._isRendering) {
          startRecordingGetsForComponent(this);
          this._isRendering = true;
        }

        var props = Object.assign(Object.assign({}, this.props), {
          store: this.state.store
        });
        return React$1.createElement(ComponentToWrap, Object.assign({}, props));
      }
    }]);

    return WrappedComponent;
  }(React$1.PureComponent);

  WrappedComponent.displayName = "Collected(".concat(componentName, ")"); // @ts-ignore - I can't work this out

  return hoistNonReactStatics$1(WrappedComponent, ComponentToWrap);
};

export default collect;